import React from "react";
import { Button, Col, Form, Icon, Input, message, Row } from "antd";
import { connect } from "react-redux";

import { Parse } from "parse";
Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");
const FormItem = Form.Item;

class MessageForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = { visible: false, text: null };
		this.onChangeText = this.onChangeText.bind(this);
	}

	///   Emit Empty pour vider les champs texte ///

	emitEmptyText = () => {
		this.setState({ text: null });
		this.props.form.setFieldsValue({ text: null });
	};

	//

	onChangeText = e => {
		this.setState({ text: e.target.value });
	};

	handleSubmit = e => {
		var ctx = this;
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				Parse.Cloud.run("sendMessage", {toId: ctx.props.to, text: values.text})
				.then(function(){
					//clear text input
					ctx.emitEmptyText();
					//fetch other messages directly in parent component chat.js
					ctx.props.getMessages(ctx.props.to)
				}).catch(function(error){
					message.error("Erreur : ", error)
				})

		}
	});
	};

	render() {
		const { getFieldDecorator } = this.props.form;
		var text = this.state.text;

		const suffixText =
			text !== null && text.length > 0 ? (
				<Icon type="close-circle" onClick={this.emitEmptyText} />
			) : null;

		return (
			<Row>
					Ecrire un nouveau message
					<Row>
						<Form onSubmit={this.handleSubmit} className="login-form">
							<Col xs={20}>
								<FormItem>
									{getFieldDecorator("text", {
										rules: [{ required: true, message: "Ecrivez votre message" }]
									})(
										<Input
											prefix={
												<Icon type="edit" style={{ color: "rgba(0,0,0,.25)" }} />
											}
											suffix={suffixText}
											type="text"
											onChange={this.onChangeText}
											placeholder="Votre message"
										/>
									)}
								</FormItem>
							</Col>

							<Col xs={{offset: 1, span: 3}}>
								<Button
									style={{ fontSize: '14px', color: "#fff", backgroundColor: "#0000FE", borderColor:"#0000FE"}}
									htmlType="submit"
									float="right"
								>
									Envoyer
								</Button>
							</Col>
						</Form>
					</Row>
			</Row>
		);
	}
}

const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
	return {
		submitComment(messages) {
			dispatch({ type: "NEW_MESSAGE", messages: messages });
		}
	};
};

const ConnectedMessageForm = Form.create()(MessageForm);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ConnectedMessageForm);
